<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <div class="topBackRect" />
    <div class="topImg">
      <van-swipe v-if="data">
        <van-swipe-item>
          <img v-lazy="data.type.cardImgFront?data.type.cardImgFront:'/img/defaultcertificate.jpg'">
        </van-swipe-item>
        <van-swipe-item>
          <img v-lazy="data.type.cardImgBack?data.type.cardImgBack:'/img/defaultcertificate.jpg'">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-if="data" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()"><b>{{ data.type.name }}</b></div>
      <van-row gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">简介</van-col>
        <van-col span="18">
          {{ data.type.resume }}
        </van-col>
      </van-row>
      <van-row gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">会员卡号</van-col>
        <van-col span="18">
          {{ data.card.vipId }}
          <template v-if="data.card.isPayFinish">
            <van-tag v-if="!data.card.isEnable" :color="GetColorMainBack()" type="primary">已停用</van-tag>
          </template>
          <van-tag v-if="!data.card.isPayFinish" :color="GetColorMainBack()" type="primary">未支付</van-tag>
        </van-col>
      </van-row>
      <van-row v-if="!data.card.isPayFinish" gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">订单关闭</van-col>
        <van-col span="18">
          <van-count-down v-if="data.autoCloseTimeMs>0" :time="data.autoCloseTimeMs" />
          <span v-if="data.autoCloseTimeMs<=0">即将关闭</span>
        </van-col>
      </van-row>

      <van-row gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">卡主</van-col>
        <van-col span="18">
          {{ data.card.viperName }} {{ data.card.viperPhoneNumber }}
        </van-col>
      </van-row>
      <van-row gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">有效期</van-col>
        <van-col span="18">
          {{ data.card.createTime?formatDate(data.card.createTime,'yyyy/MM/dd',false):'-' }} 至
          {{ data.card.finishTime?formatDate(data.card.finishTime,'yyyy/MM/dd',false):'-' }}
          <van-tag v-if="!data.isInActivityTime" style="margin-left:0.5em" :color="GetColorMainBack()">未生效</van-tag>
        </van-col>
      </van-row>
      <van-row v-if="data.card.isPayFinish" gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">积分</van-col>
        <van-col span="18">
          {{ data.card.score }}分
        </van-col>
      </van-row>
      <van-row v-if="data.card.isPayFinish" gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">余额</van-col>
        <van-col span="18">
          CNY {{ ShowMoney(data.card.cashFee*0.01) }}
        </van-col>
      </van-row>
      <van-row v-if="data.card.isPayFinish" gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">赠送余额</van-col>
        <van-col span="18">
          CNY {{ ShowMoney(data.card.cashGiftFee*0.01) }}
        </van-col>
      </van-row>
      <template v-if="data.card.isPayFinish">
        <template v-for="item in data.itemList">
          <van-row v-if="item.type==='COUNT' || item.type==='INVITATION_CODE' || item.type==='TEXT'" :key="item.cardItemId" gutter="20" class="valueRect">
            <template v-if="item.type==='COUNT'">
              <van-col span="6" :style="'color:'+GetColorMainBack()">{{ item.title }}</van-col>
              <van-col span="18">
                当前剩余<b>{{ item.n_NowValue }}</b>{{ item.unitName }}
                <van-button v-if="item.isTrip" type="primary" size="mini" :color="GetColorMainBack()" :disabled="!data.isInActivityTime" style="padding:0 0.5em;" @click="onSubscribe(item.cardItemId)">预约</van-button>
              </van-col>
            </template>
            <template v-if="item.type==='TEXT'">
              <van-col span="6" :style="'color:'+GetColorMainBack()">{{ item.title }}</van-col>
              <van-col span="18">
                {{ item.about }}
                <van-button v-if="item.isTrip" type="primary" size="mini" :color="GetColorMainBack()" :disabled="!data.isInActivityTime" style="padding:0 0.5em;" @click="onSubscribe(item.cardItemId)">预约</van-button>
              </van-col>
            </template>
            <template v-if="item.type==='INVITATION_CODE'">
              <van-col span="6" :style="'color:'+GetColorMainBack()">{{ item.title }}</van-col>
              <van-col span="18">
                当前剩余<b>{{ item.n_NowValue }}</b>{{ item.unitName }}
                <van-button v-if="item.n_NowValue>0" type="primary" size="mini" :color="GetColorMainBack()" style="padding:0 0.5em;" @click="onGetInvitationCode">获取邀请码</van-button>
                <!-- :disabled="!data.isInActivityTime"  -->
              </van-col>
            </template>
          </van-row>
        </template>
      </template>
    </div>
    <div v-if="invitationCode && invitationCode.length>0" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()">邀请码</div>

      <van-row v-for="(item,index) in invitationCode" :key="item.sellCodeId" gutter="20" class="valueRect">
        <van-col span="6" :style="'color:'+GetColorMainBack()">邀请码{{ (index+1) }}</van-col>
        <van-col span="18">
          {{ item.hashCode }}  <van-tag v-if="item.isUsed" style="margin-left:0.5em" :color="GetColorMainBack()">已使用</van-tag>

          <van-button v-if="!item.isUsed" v-clipboard:success="onCopySuccess" v-clipboard:copy="copyStr" :disabled="!item.isCanUsed" style="margin-left:0.5em;padding:0 0.5em" size="mini" :color="GetColorMainBack()" @click="onCopy(item)">复制邀请码</van-button>

          <van-count-down v-if="item.beginTick>0" :time="item.beginTick" class="limitDate" format="DD 天 HH 时 mm 分后可用" />
          <van-count-down v-if="item.beginTick<=0 && item.endTick>0" class="limitDate" :time="item.endTick" format="DD 天 HH 时 mm 分后失效" />
          <div v-if="!item.isCanUsed" class="limitDate">已失效</div>
        </van-col>
      </van-row>

    </div>
    <div v-if="data && data.type.about" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()">详情</div>
      <div class="aboutStr" v-html="data.type.about" />
    </div>

    <div v-if="data && data.logList" class="dataRect">
      <div class="rectTitle" :style="'color:'+GetColorMainBack()">使用记录</div>
      <table class="logTable" cellspacing="0">
        <tr>
          <th>日期</th>
          <th>项目</th>
          <th>介绍</th>
        </tr>
        <tr v-for="item in data.logList" :key="item.cardLogId">
          <td>{{ formatDate(item.createTime,"MM/dd hh:mm",true) }}</td>
          <td>{{ item.n_itemName }}</td>
          <td>{{ item.about }}</td>
        </tr>
      </table>
    </div>

    <div class="emptyRect" />
    <div v-if="data" class="buttonRect">
      <template v-if="data.card.isPayFinish">
        <van-row gutter="20">
          <van-col span="12">
            <van-button v-if="!data.card.userId" type="primary" class="button" :color="GetColorSecondary()" @click="onBindMemberCard(data.card.hashCode)">绑定会员卡</van-button>
            <van-button v-if="data.card.userId" type="danger" class="button" :color="GetColorSecondary()" @click="onUnBindMemberCard(data.card.hashCode)">解绑会员卡</van-button>
          </van-col>
          <van-col span="12"><van-button type="primary" class="button" :color="GetColorMainBack()" @click="onHelp">客服</van-button></van-col>
        </van-row>
      </template>
      <template v-if="!data.card.isPayFinish">
        <van-button v-if="!data.card.moneyId" type="primary" :disabled="data.autoCloseTimeMs<0" class="button" :color="GetColorMainBack()" @click="onPayMemberCard">支付购买</van-button>
        <van-button v-if="data.card.moneyId" type="primary" class="button" :color="GetColorMainBack()" @click="onViewPayMemberCard(data.card.moneyId)">查看支付结果</van-button>
      </template>
    </div>
    <payDialog v-model="isShowPayPage" :data-obj="payInfoObject" @onPay="onPaySubject" />
    <van-dialog v-model="showHelper" title="联系客服" show-cancel-button>
      <div v-if="data && data.type" class="helpRect" v-html="data.type.helperString" />
    </van-dialog>
    <followWx v-model="showFollow" @finish="onFollowFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Dialog, Swipe, SwipeItem, Lazyload, Tag, CountDown } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, ShowMoney, GetEnumText, formatDate, MyNotify } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import payDialog from '@/components/payDialog'
import { GetSelfUrl } from '@/utils/request'
import followWx from '@/components/followWx'

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Button.name]: Button,
    [Lazyload.name]: Lazyload,
    [Tag.name]: Tag,
    [CountDown.name]: CountDown,
    TopBar,
    payDialog,
    followWx
  },
  data() {
    return {
      titleTop: '',
      title: '我的会员卡',
      backurl: '/memberCard/memberCardList',
      hashCode: undefined,
      data: undefined,
      loadingPage: true,
      isShowPayPage: false,
      payInfoObject: undefined,
      isNativePay: false,
      invitationCode: [],
      copyStr: '',
      system: '',
      showHelper: false,
      showFollow: false
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.system = getUrlKey('system')
    this.isNativePay = getUrlKey('pay')
    this.hashCode = this.$route.params.code
    this.init()
  },
  methods: {
    getUrlKey,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    MyNotify,
    GetSelfUrl,
    init() {
      this.loadingPage = true
      request({
        url: '/MemberCard/GetMemberCardInfo',
        method: 'post',
        params: { hashCode: this.hashCode }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.loadInvitationCode()
        if (this.isNativePay && !this.data.card.isPayFinish && this.data.autoCloseTimeMs > 0) {
          this.onPayMemberCard()
          return
        }

        if (!this.data.card.userId) {
          Dialog.confirm({
            title: '是否绑定该会员卡',
            message: '当前会员卡尚未绑定，是否绑定?',
            confirmButtonText: '立即绑定',
            cancelButtonText: '暂不绑定'
          }).then(() => {
            this.onBindMemberCard(this.data.card.hashCode)
          }).catch(() => {
          })
        }
      })
    },
    onBindMemberCard(hashCode) {
      request({
        url: '/MemberCard/bingMemberCard',
        method: 'post',
        params: { hashCode: hashCode }
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '会员卡绑定成功!')
      })
    },
    onUnBindMemberCard(hashCode) {
      Dialog.confirm({
        title: '是否解绑当前会员卡？',
        message: '是否解绑当前会员卡？请先找到您的实体卡片或者找到您的注册二维码，以免卡片信息丢失无法再次绑定！',
        confirmButtonText: '立即解绑',
        cancelButtonText: '暂不解绑'
      }).then(() => {
        this.onUnBindMemberCardDo(hashCode)
      }).catch(() => {
      })
    },
    onUnBindMemberCardDo(hashCode) {
      request({
        url: '/MemberCard/unBingMemberCard',
        method: 'post',
        params: { hashCode: hashCode }
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '会员卡解除绑定成功!')
      })
    },
    onHelp() {
      this.showHelper = true
      // Dialog.alert({
      //   title: '帮助',
      //   message: '请联系客服获得帮助'
      // })
    },
    onFollowFinish() {
      this.onPayMemberCardDo()
    },
    onPayMemberCard() {
      Dialog.confirm({
        title: '请关注公众号',
        message: '请关注公众号以便于查询您的会员卡信息.',
        confirmButtonText: '立刻关注',
        cancelButtonText: '暂不关注'
      }).then(() => {
        this.showFollow = true
      }).catch(() => {
        this.onPayMemberCardDo()
      })
    },
    onPayMemberCardDo() {
      var message = '您所购买的[' + this.data.type.name + ']有效期为:' +
      (this.data.card.createTime ? formatDate(this.data.card.createTime, 'yyyy/MM/dd', false) : '-') +
      ' 至 ' + (this.data.card.finishTime ? formatDate(this.data.card.finishTime, 'yyyy/MM/dd', false) : '-') +
      '。请核对'
      Dialog.confirm({
        title: '注意',
        message: message,
        confirmButtonText: '支付',
        cancelButtonText: '取消'
      }).then(() => {
        this.isShowPayPage = true
        this.payInfoObject = {
          title: '支付会员卡',
          about: '购买' + this.data.type.name + '会员卡,卡号:' + this.data.card.vipId,
          isSystem: false,
          price: this.data.type.sellPriceFee * 0.01
        }
      }).catch(() => {
      })
    },
    onViewPayMemberCard(moneyId) {
      this.$router.push('/store/pay/0?id=' + moneyId)
    },
    onPaySubject(moneyChannelId) {
      console.log('moneyChannelId', moneyChannelId)
      request({
        url: '/MemberCard/payMemberCard',
        method: 'post',
        data: { hashCode: this.data.card.hashCode,
          moneyChannelId: moneyChannelId }
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '订单创建成功!')
        this.$router.push('/store/pay/0?id=' + response.data)
      })
    },
    onSubscribe(cardItemId) {
      this.$router.push('/memberCard/subscribelist?itemId=' + cardItemId + '&hashCode=' + this.hashCode)
    },
    onGetInvitationCode() {
      request({
        url: '/MemberCard/CreateUserInvitationCode',
        method: 'post',
        params: { hashCode: this.data.card.hashCode }
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '生成邀请码成功!')
        this.init()
      })
    },
    loadInvitationCode() {
      if (!this.data || !this.data.card.userId || !this.data.card.isPayFinish) {
        return
      }
      request({
        url: '/MemberCard/GetUserInvitationCode',
        method: 'post',
        params: { hashCode: this.data.card.hashCode }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.invitationCode = response.data
      })
    },
    onCopy(item) {
      var copyStr = this.data.card.viperName + '邀请你购买' + this.data.type.name + '。打开: ' +
        GetSelfUrl() + 'memberCard/buy/0?typeid=' + item.typeId + '&system=' + this.system + ' 输入邀请码:' + item.hashCode + '即可购买!'
      this.copyStr = copyStr
    },
    onCopySuccess(e) {
      MyNotify('success', '已复制:' + e.text, 2000)
    }
  }
}
</script>
<style scoped>
.topBackRect{
  position: absolute;
  background-color: #000;
  width: 100%;
  height: 20vh;

}
.topImg{
  padding: 1em;
  border-radius: 1em;
  overflow: hidden;
}
.topImg img{
  width:100%;
  min-height: 40vw;
  border-radius: 1em;
  overflow: hidden;
}
.dataRect{
  background-color: #fff;
  margin-bottom: 1em;
  padding: 1em;
}
.dataRect .valueRect{
  font-size: 0.8em;
  padding: 0.4em 0;
}
.dataRect .rectTitle{
  font-size: 0.9em;
  font-weight: 700;
  padding-bottom: 0.5em;
}
.logTable{
  width: 100%;
  font-size: 0.8em;
  border:1px solid #fafafa;
}
.logTable td{
  border:1px solid #fafafa;
  padding: 0.25em;
}
.aboutStr{
  font-size: 0.8em;
}
.aboutStr img{
  max-width: 100%;
}
.emptyRect{
  height: 3em;
}
.buttonRect{
  z-index: 10;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3em;
  background-color: #fff;
  border-top: 1px solid #f5f5f5;
}
.buttonRect .button{
  width:100%;
  height:3em;
  line-height:3em;
}
.helpRect{
  padding: 0.5em;
}
.helpRect img{
  max-width: 100%;
}
.limitDate{
  color: #999;
  font-size: 0.9em;
  padding: 0.25em 0;
}
</style>
